/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import './BbCategories.css';

class Categories extends React.Component {
  constructor(props) {
    super(props);
    this.onCategoriesChildChange = this.onCategoriesChildChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.cats !== this.props.cats) {
      return true;
    }
    return false;
  }

  onCategoriesChildChange(e) {
    e.preventDefault();
    // Send the category selection id to parent: Welcome
    this.props.onCategoriesChildChange(e.target.dataset);
  }

  toArray(o) {
    const a = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const name in o) {
      a[name] = o[name];
    }
    return a;
  }

  render() {
    const catsO = this.props.cats !== 'undefined' ? this.props.cats : {};
    const catsA = [];
    const peopleCats = [];
    const placesCats = [];
    const thingsCats = [];
    const animalsCats = [];
    let peopleCatId;
    let placesCatId;
    let thingsCatId;
    let animalsCatId;
    // eslint-disable-next-line no-unused-vars, no-restricted-syntax
    for (const [key, categories] of Object.entries(catsO)) {
      categories.forEach((thisCat) => {
        catsA.push(this.toArray(thisCat));
      });
    }
    catsA.forEach((cat) => {
      if (cat.cat === 'People') {
        peopleCatId = cat.id;
      } else if (cat.cat === 'Places') {
        placesCatId = cat.id;
      } else if (cat.cat === 'Things') {
        thingsCatId = cat.id;
      } else if (cat.cat === 'Animals') {
        animalsCatId = cat.id;
      }
      if (cat.parent === peopleCatId) {
        peopleCats.push(cat);
      } else if (cat.parent === placesCatId) {
        placesCats.push(cat);
      } else if (cat.parent === thingsCatId) {
        thingsCats.push(cat);
      } else if (cat.parent === animalsCatId)
      {
        animalsCats.push(cat);
      }
    });

    const peopleContent = peopleCats.map((cat) => (cat.ct > 0 ? (
      <ul key={`ul${cat.id.toString()}`}>
        <li key={`li${cat.cat_dir}`}>
          <a
            className="btn btn-med btn-outline-primary d-flex justify-content-between"
            key={cat.cat_dir}
            data-catid={cat.id}
            data-rmkey={this.props.roomKey}
            href="#"
            onClick={this.onCategoriesChildChange}
          >
            {cat.cat}
            {' '}
            <span className="catct">
              (
              {' '}
              {cat.ct}
              {' '}
              )
            </span>
          </a>
        </li>
      </ul>
    ) : (
      ''
    )));

    const animalsContent = animalsCats.map((cat) => (cat.ct > 0 ? (
      <ul key={`ul${cat.id.toString()}`}>
        <li key={`li${cat.cat_dir}`}>
          <a
            className="btn btn-med btn-outline-primary d-flex justify-content-between"
            key={cat.cat_dir}
            data-catid={cat.id}
            data-rmkey={this.props.roomKey}
            href="#"
            onClick={this.onCategoriesChildChange}
          >
            {cat.cat}
            {' '}
            <span className="catct">
              (
              {' '}
              {cat.ct}
              {' '}
              )
            </span>
          </a>
        </li>
      </ul>
    ) : (
      ''
    )));

    const placesContent = placesCats.map((cat) => (cat.ct > 0 ? (
      <ul key={`ul${cat.id.toString()}`}>
        <li key={`li${cat.cat_dir}`}>
          <a
            className="btn btn-lg btn-outline-primary d-flex justify-content-between"
            key={cat.cat_dir}
            data-catid={cat.id}
            data-rmkey={this.props.roomKey}
            href="#"
            onClick={this.onCategoriesChildChange}
          >
            {cat.cat}
            {' '}
            <span className="catct">
              (
              {' '}
              {cat.ct}
              {' '}
              )
            </span>
          </a>
        </li>
      </ul>
    ) : (
      ''
    )));

    const thingsContent = thingsCats.map((cat) => (cat.ct > 0 ? (
      <ul key={`ul${cat.id.toString()}`}>
        <li key={`li${cat.cat_dir}`}>
          <a
            className="btn btn-lg btn-outline-primary d-flex justify-content-between"
            key={cat.cat_dir}
            data-catid={cat.id}
            data-rmkey={this.props.roomKey}
            href="#"
            onClick={this.onCategoriesChildChange}
          >
            {cat.cat}
            {' '}
            <span className="catct">
              (
              {' '}
              {cat.ct}
              {' '}
              )
            </span>
          </a>
        </li>
      </ul>
    ) : (
      ''
    )));

    return (
      <div>
        <p>
          Begin play, in your private game room, by
          selecting one of the categories below.
        </p>
        <div className="accordion" id="accordionExample">

          {/* PEOPLE */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingPeople">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsePeople"
                aria-expanded="false"
                aria-controls="collapsePeople"
              >
                People
              </button>
            </h2>
            <div
              id="collapsePeople"
              className="accordion-collapse collapse"
              aria-labelledby="headingPeople"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">{peopleContent}</div>
            </div>
          </div>

          {/* ANIMALS */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingAnimals">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseAnimals"
                aria-expanded="false"
                aria-controls="collapseAnimals"
              >
                Animals
              </button>
            </h2>
            <div
              id="collapseAnimals"
              className="accordion-collapse collapse"
              aria-labelledby="headingAnimals"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">{animalsContent}</div>
            </div>
          </div>

          {/* PLACES */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingPlaces">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsePlaces"
                aria-expanded="false"
                aria-controls="collapsePlaces"
              >
                Places
              </button>
            </h2>
            <div
              id="collapsePlaces"
              className="accordion-collapse collapse"
              aria-labelledby="headingPlaces"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">{placesContent}</div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThings">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThings"
                aria-expanded="false"
                aria-controls="collapseThings"
              >
                Things
              </button>
            </h2>
            <div
              id="collapseThings"
              className="accordion-collapse collapse"
              aria-labelledby="headingThings"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">{thingsContent}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Categories;
